<template>
  <v-card flat>
    <v-list-item two-line class="pt-0">
      <v-list-item-content>
        <v-list-item-title class="headline"
          >{{ this.$t('mutation.list.title') }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-container fluid>
        <v-layout row>
          <v-flex md2>
            <search-by
              ref="search"
              :datasource="datasource"
              attr="enCours"
              :check="true"
              @emitsearchby="emitsearchby"
            />
          </v-flex>
          <v-flex md2 v-if="roleCorrespondantEtablissement">
            <search-by
              ref="search"
              :datasource="datasource"
              attr="entrantes"
              :check="true"
              @emitsearchby="emitsearchby"
            />
          </v-flex>
          <v-flex md2 v-if="roleCorrespondantEtablissement">
            <search-by
              ref="search"
              :datasource="datasource"
              attr="sortantes"
              :check="true"
              @emitsearchby="emitsearchby"
            />
          </v-flex>
        </v-layout>
        <v-card>
          <datasource-table
            :useLinkTo="true"
            ref="dataTable"
            :datasource="datasource"
          >
            <template #item="{ item }">
              <tr @click="$router.push(datasource.linkTo(item))">
                <td>{{ item.date }}</td>
                <td>{{ item.auteurMouvement }}</td>
                <td>
                  {{ item.participant.nom + ' ' + item.participant.prenom }}
                </td>
                <td>
                  <v-icon v-if="item.allowedToCancel == true">mdi-check</v-icon>
                  <v-icon v-if="item.allowedToCancel == false"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </td>
                <td>
                  {{
                    item.etablissementDestination
                      ? item.etablissementDestination.raisonSociale
                      : ''
                  }}
                </td>
                <td>
                  {{
                    item.etablissementSource
                      ? item.etablissementSource.raisonSociale
                      : ''
                  }}
                </td>
                <td>{{ item.motifMouvement }}</td>
                <td>
                  <v-avatar
                    color="teal"
                    :style="{ height: '32px', minWidth: '32px', width: '32px' }"
                    v-if="item.bilanEnCours"
                  >
                    <span class="white--text headline">B</span>
                  </v-avatar>
                </td>
              </tr>
            </template>
          </datasource-table>
        </v-card>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource'
import moment from 'moment'

export default {
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    capabilities: {
      type: String,
      default: '',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    roleCorrespondantEtablissement() {
      return (
        this.$auth.hasRole('ROLE_CORRESPONDANT') &&
        this.$auth.correspondantEtablissement()
      )
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.datasource.args.idTechnique = this.$auth.idTechnique();
      this.datasource.refresh()
    })
  },
  data() {
    const datasource = new Datasource('mutation', {
      page: 1,
      rowsPerPage: 20,
      sortBy: 'date',
      descending: true,
      labelNamespace: 'mutation.list',
      args: { enCours: true },
      customRowClass: (item) => (item.enCours ? 'mutation-encours' : ''),
      fields: [
        // ...this.fieldName,

        {
          value: 'date',
          sortable: true,
        },
        {
          value: 'auteurMouvement',
          sortable: false,
        },
        {
          value: 'participant',
          sortable: false,
        },
        {
          value: 'allowedToCancel',
          sortable: false,
        },
        {
          value: 'etablissementDestination',
          sortable: false,
        },
        {
          value: 'etablissementSource',
          sortable: false,
        },

        {
          value: 'motifMouvement',
          sortable: false,
        },
        {
          value: 'bilanEnCours',
          sortable: false,
        },
      ],
    })

    return {
      datasource,
    }
  },
  methods: {
    selectedItemTraitements() {},

    emitsearchby(attr, value) {
      if (attr == 'entrantes' && value == true) {
        this.datasource.args['sortantes'] = false
      } else if (attr == 'sortantes' && value == true) {
        this.datasource.args['entrantes'] = false
      }
      this.datasource.args[attr] = value
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : null
    },
  },
}
</script>
<style>
.mutation-encours {
  background-color: #90d4fc;
}
</style>
